import i18next from 'i18next';

i18next.addResources('es_CL', 'Profile', {
  yourData: 'Tus Datos',
  yourAddresses: 'Tus Direcciones',
  yourPaymentMethods: 'Medios de Pagos',
  logout: 'Salir de la cuenta',
  backToHome: 'Volver al home'
});
